import { Icon } from '@gitbook/spine-icons';
import { SidebarButton } from '@gitbook/spine-react';

import { useFeedbackButton } from '../../Components';

export function FeedbackButton() {
    const { isEnabled, buttonProps } = useFeedbackButton({
        flagKey: 'APP_WIDE_FEEDBACK',
    });

    if (!isEnabled) {
        return null;
    }

    return (
        <SidebarButton
            {...buttonProps}
            iconOnly
            outlined
            icon={Icon.Happy}
            label="Share feedback"
        />
    );
}
